import styled from 'styled-components';

export const Copyright = styled.p`
  font-size: 14px;
`;
